import { SidebarNavButton } from '@components/layout/SidebarNavButton';
import { Button } from '@components/atoms/Button';
import AddIcon from '@mui/icons-material/Add';

interface Props {
  items: any[];
  selectedItem: any;
  className?: string;
  addButtonLabel?: string;
  toggleModal?: () => void;
  handleMenuItemClick?: (client: any) => void;
  filterSlot?: React.ReactNode;
  disabled?: boolean;
}

export const SecondarySidebar = ({
  items,
  className,
  toggleModal,
  selectedItem,
  addButtonLabel,
  handleMenuItemClick,
  filterSlot,
  disabled = false,
}: Props) => {
  return (
    <div
      className={`fixed left-52 top-0 self-stretch flex bg-[#43378F] dark:bg-gray-800 min-w-52 max-w-52 h-screen flex-col items-start overflow-y-auto transition-colors duration-200 [scrollbar-width:thin] [scrollbar-color:rgba(255,255,255,0.4)_rgba(139,92,246,0.2)] dark:[scrollbar-color:rgba(255,255,255,0.3)_rgba(31,41,55,0.3)] mr-6 ${className}`}>
      {addButtonLabel && toggleModal && (
        <div className="p-2 w-full">
          <Button
            fullWidth
            onClick={toggleModal}
            disabled={disabled}
            leftIcon={
              <AddIcon className="text-indigo-800 dark:text-indigo-100" />
            }
            className="mt-2 !bg-blue-100 dark:!bg-gray-700 !text-indigo-900 dark:!text-indigo-100">
            {addButtonLabel}
          </Button>
        </div>
      )}
      {filterSlot && <div className="p-2 w-full">{filterSlot}</div>}
      <div className="flex w-full flex-col items-start mt-3">
        {items.map((item) =>
          item?.isSectionHeader ? (
            <div
              key={item.id}
              className="w-full px-3.5 pt-4 pb-1 text-[11px] font-semibold uppercase tracking-wider text-white/50">
              {item.name}
            </div>
          ) : (
            <SidebarNavButton
              key={item.id}
              label={item.name}
              iconRight={item?.iconRight}
              subtitle={
                item?.subtitle ||
                (item?.originalProject && `Delegated by ${item.originalProject}`)
              }
              active={selectedItem === item.id}
              onClick={() => handleMenuItemClick?.(item)}
              className={
                selectedItem === item.id
                  ? 'border-r-2 border-orange-400 dark:border-orange-300'
                  : ''
              }
            />
          ),
        )}
      </div>
    </div>
  );
};
